/**
 * selfPayInsurance.js — PROD-1132 Q1 (Alex 2026-10-18): THE body that answers the insurance question
 * with "self-pay" from outside the insurance screens, and THE rule for when that offer is made.
 *
 * The before-share block (missingBeforeShare: ShareHub, Diagnose, Share) keeps stopping a share while
 * insurance is not on file, and also offers "Continue without insurance" right there. That answer is
 * the onboarding insurance step's self-pay answer, field for field: what its "Continue without
 * insurance" tap puts in the store (selfPay true, payerPick 'clear', member ID and group number empty,
 * coverageType 'self-pay') as its section save sends it (useOnboardingStore.buildSectionPatch step 3:
 * insurerName = provider, planType = coverageType, every payer key, completed true). Keys that save
 * sends only from what the store already holds (policyholder, card images, discovery_result,
 * last_eligibility, pcp) are not sent here: PUT /profile shallow-merges insurance, so they stay as
 * they are, the same as the onboarding save over a hydrated store. No ipa / ipaId (onboarding sends
 * neither).
 *
 * selfPayOffered: the offer is made ONLY to a patient whose single missing section is insurance and
 * who has NO carrier + member ID on file and is not self-pay already. A patient with a card on file
 * (even one Profile > Insurance autosave left `completed: false`) never sees it, so this body never
 * empties a stored carrier and member ID (review HIGH-1, MEDIUM-1).
 */
import { payerPick } from './payerPick'
import { hasCarrierAndMemberId } from './discoverySearch'

export function selfPayInsuranceBody() {
  return {
    selfPay: true,
    coverageType: 'self-pay',
    ...payerPick({ kind: 'clear' }),
    memberId: '',
    groupNumber: '',
    insurerName: '',
    planType: 'self-pay',
    completed: true,
  }
}

export function selfPayOffered(missing, insurance) {
  if (!Array.isArray(missing) || missing.length !== 1 || missing[0] !== 'insurance') return false
  const ins = insurance || {}
  if (ins.selfPay === true || String(ins.coverageType || '').trim().toLowerCase() === 'self-pay') return false
  return !hasCarrierAndMemberId(ins)
}
